export function closeWidget() {
  window.parent.postMessage({ close: true }, "*");
}
